/**
 * Created by andrey on 21.08.17.
 */

const CrabAnimation = BaseAnimation.extend({ 
    ctor: function (bundle, lives) {
        this._super(bundles[bundle].jsons[`${bundle}_spine_json`], bundles[bundle].frames[`cell_crab${lives}`]);
    }
});

CrabAnimation.factory = function (bundle, lives) {
    return cleverapps.pool.hasObject(CrabAnimation) ? cleverapps.pool.getFromPool(CrabAnimation) : new CrabAnimation(bundle, lives);
};